import * as types from "../mutation-types";
import * as DateUtils from '~/utils/date.js';
import Vue from 'vue';

let range = DateUtils.initRangeDate();

// state
export const state = {
    from: range.start,
    to: range.end,
    database:undefined,
    leadType:'all',
    filter_advance:{}

};

// getters
export const getters = {
    from: state => state.from,
    to: state => state.to,
    database: state => state.database,
    leadType: state => state.leadType,
    filter_advance: state => state.filter_advance
};

// mutations
export const mutations = {
    [types.SAVE_RANGE_DATE](state, { from, to }) {
        Vue.set(state, 'from', from);
        Vue.set(state, 'to', to);
    },
    [types.DATABASE](state, { database }) {
        Vue.set(state, 'database', database);
    },
    [types.LEAD_TYPE](state, { leadType }) {
        Vue.set(state, 'leadType', leadType);
    },
    [types.FILTER_ADVANCE](state, { filter_advance }) {
        Vue.set(state, 'filter_advance', filter_advance);
    },
    

};

// actions
export const actions = {
    saveRangeDate({ commit }, payload) {
        let from = payload.start;
        let to = payload.end;
        commit(types.SAVE_RANGE_DATE, {
            from,
            to
        })
    },
    saveDatabase({ commit }, payload) {
        let database = payload.database;
        commit(types.DATABASE, {
            database
        });
    },
    saveLeadType({ commit }, payload) {
        let leadType = payload.leadType;
        commit(types.LEAD_TYPE, {
            leadType
        });
    },
    saveFilterAdvance({ commit }, payload) {
        let filter_advance = payload.filter_advance;
        commit(types.FILTER_ADVANCE, {
            filter_advance
        });
    },
};
